const SidebarMenu = [
    {
        menu: "Dashboard",
        activeImg: require('../images/menu/dashboard_active.svg').default,
        inactiveImg: require('../images/menu/dashboard_inactive.svg').default,
        pathName: '/dashboard',
        allPath: ['/dashboard'],
        display: ["all"],
        children: [],
    },
    {
        menu: "Member",
        activeImg: require('../images/menu/profile_active.svg').default,
        inactiveImg: require('../images/menu/profile_inactive.svg').default,
        pathName: '/member',
        allPath: ['/member/rankError','/member', '/member/member-details', '/member/lookup-sponsor', '/member/direct-downline', '/member/teamHierarchy', '/member/memberKYC', '/member/rankLog'],
        display: ["all"],
        children: [
            {
                menu: "Member Details",
                pathName: '/member/member-details',
                allPath: ['/member/member-details'],
            },
            {
                menu: "Lookup Sponsor",
                pathName: '/member/lookup-sponsor',
                allPath: ['/member/lookup-sponsor'],
            },
            {
                menu: "Direct Downline",
                pathName: '/member/direct-downline',
                allPath: ['/member/direct-downline'],
            },
            {
                menu: "Overall Team Hierarchy",
                pathName: '/member/teamHierarchy',
                allPath: ['/member/teamHierarchy'],
            },
            {
                menu: "Member KYC",
                pathName: '/member/memberKYC',
                allPath: ['/member/memberKYC'],
            },
            {
                menu: "Rank Log",
                pathName: '/member/rankLog',
                allPath: ['/member/rankLog'],
            },
        ]
    },
    {
        menu: "Wallet",
        activeImg: require('../images/menu/wallet_active.svg').default,
        inactiveImg: require('../images/menu/wallet_inactive.svg').default,
        pathName: '/wallet',
        allPath: ['/wallet/transfer','/wallet/transaction', '/wallet/purchaseHistory', '/wallet/balance', '/wallet/walletWithdrawal', '/wallet/walletCrmDeposit', '/wallet/walletMt5Deposit', '/wallet/adjust'],
        display: ["all"],
        children: [
            {
                menu: "Wallet Transaction",
                pathName: '/wallet/transaction',
                allPath: ['/wallet/transaction'],
            },
            {
                menu: "CRM Withdrawal",
                pathName: '/wallet/walletWithdrawal',
                allPath: ['/wallet/walletWithdrawal'],
            },

            {
                menu: "CRM Deposit",
                pathName: '/wallet/walletCrmDeposit',
                allPath: ['/wallet/walletCrmDeposit'],
            },
            {
                menu: "MT5 Deposit",
                pathName: '/wallet/walletMt5Deposit',
                allPath: ['/wallet/walletMt5Deposit'],
            },
            {
                menu: "Internal Transfer",
                pathName: '/wallet/transfer',
                allPath: ['/wallet/transfer'],
            },
            {
                menu: "Wallet Balance",
                pathName: '/wallet/balance',
                allPath: ['/wallet/balance'],
            },
            {
                menu: "Wallet Adjust",
                pathName: '/wallet/adjust',
                allPath: ['/wallet/adjust'],
            },
        ]
    },
    {
        menu: "Bonus",
        activeImg: require('../images/menu/investment_active.svg').default,
        inactiveImg: require('../images/menu/investment_inactive.svg').default,
        pathName: '/bonus',
        allPath: ['/bonus/profitSharingBonusList','/bonus/lotBonusList', '/bonus/periodExtraProfitList', '/bonus/sameRankBonusList', '/bonus/contractCommissionList', '/bonus/earlyBirdBonusList', '/bonus/vipBonusList', '/bonus/mt5ProfitList'],
        display: ["all"],
        children: [
            {
                menu: "MT5 Profit",
                pathName: '/bonus/mt5ProfitList',
                allPath: ['/bonus/mt5ProfitList'],
            },
            {
                menu: "Lot Rebate Bonus",
                pathName: '/bonus/lotBonusList',
                allPath: ['/bonus/lotBonusList'],
            },
            {
                menu: "Profit Sharing Bonus",
                pathName: '/bonus/profitSharingBonusList',
                allPath: ['/bonus/profitSharingBonusList'],
            },
            {
                menu: "Same Rank Bonus",
                pathName: '/bonus/sameRankBonusList',
                allPath: ['/bonus/sameRankBonusList'],
            },
        ]
    },
    {
        menu: "MT5",
        activeImg: require('../images/menu/investment_active.svg').default,
        inactiveImg: require('../images/menu/investment_inactive.svg').default,
        pathName: '/mt5',
        allPath: ['/mt5/mt5AccountList', '/mt5/investmentRecord'],
        display: ["all"],
        children: [
            {
                menu: "MT5 Account",
                pathName: '/mt5/mt5AccountList',
                allPath: ['/mt5/mt5AccountList'],
            },
            {
                menu: "Investment Record",
                pathName: '/mt5/investmentRecord',
                allPath: ['/mt5/investmentRecord'],
            }
        ]
    },
    {
        menu: "System",
        activeImg: require('../images/menu/setting_active.svg').default,
        inactiveImg: require('../images/menu/setting_inactive.svg').default,
        pathName: '/system',
        allPath: ["/system/customRank/edit/:id", "/system/customRank/new", "/system/customRank",'/system/specialAccount', '/system/shareholder', '/system/admin', '/system/admin/new', '/system/admin/edit/:id', '/system/announcement', '/system/announcement/new', '/system/announcement/:id', "/system/otcTagList", '/system/adminDashboard', '/system/addAdminWhiteListIpAddress', '/system/uploadProfit', '/system/liveTrade', '/system/liveTrade/new', '/system/liveTrade/:id', '/system/permission', '/system/permission/edit', '/system/permission/new', '/system/adminLog', '/system/setting', '/system/shareholder/new'],
        display: ["all"],
        children: [
            {
                menu: "Admin",
                pathName: '/system/admin',
                allPath: ['/system/admin', '/system/admin/new', '/system/admin/edit/:id'],
            },
            {
                menu: "OTC Tag List",
                pathName: '/system/otcTagList',
                allPath: ['/system/otcTagList'],
            },
            {
                menu: "Announcement",
                pathName: '/system/announcement',
                allPath: ['/system/announcement', '/system/announcement/new', '/system/announcement/:id'],
            },
            {
                menu: "Setting",
                pathName: '/system/setting',
                allPath: ['/system/setting'],
            },
            {
                menu: "Admin Dashboard",
                pathName: '/system/adminDashboard',
                allPath: ['/system/adminDashboard'],
            },
        ],
    },

]

export default SidebarMenu;